import { LockedBlurredListOverlay } from '../../../../lumpsum/plans-list/body/shared/LockedPlanPieces'
import { PlansScreen } from '../../../../analytics/plansEvents'
import { IdealSipCategoryList } from './IdealSipCategoryList'
import { SIP_IDEAL_BLURRED_CATEGORIES } from '../../../../../mock/data/blurFixtures'

/** PLAN_ROLLED_OUT but not Prime. */
export function SipIdealBlurredBody() {
  return (
    <LockedBlurredListOverlay
      message={
        <>
          Your ideal SIP&apos;s is
          <br />
          currently locked
        </>
      }
      buttonLabel="Unlock with Prime"
      landingPage="prime"
      analyticsScreen={PlansScreen.SipIdeal}
    >
      <IdealSipCategoryList categories={SIP_IDEAL_BLURRED_CATEGORIES} />
    </LockedBlurredListOverlay>
  )
}
